export const primaryColor = 'var(--clr-primary-400)'
